import api from '@/security/api'
import querystring from 'querystring'
import errorCatch from '@/helpers/errorCatch'

require('./../../security/interceptors')

const findAll = (id, objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.get(`/messages/campain/${id}?${query}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar os dados')
        })
}

export default {
    findAll
}
